"use client"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Container from "ui/Container"
import { sharedColors } from "ui/theme/colors"
import { BreadCrumbs } from "utils"
import { decodeUnicodeEscapes } from "utils/decodeUnicodeEscapes"
import { TrafficUpdateSinglePage } from "utils/transformUpdate"
import TraffixBox from "../Homepage/TrafficUpdates/TraffixBox"
import Breadcrumbs from "../PeopleOfEgged/Breadcrumbs"

const BreadContainer = styled.div`
  width: 100%;
  padding-bottom: 24px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-bottom: 48px;
  }
`

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 40px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 48px;
    padding-bottom: 48px;
  }
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-bottom: 48px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 48px;
    padding-bottom: 64px;
  }
`

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 24px;
  border-bottom: 1px solid ${sharedColors.borderGray};
`

const formatDate = (dateString: string) => {
  const date = new Date(dateString)
  const day = date.getDate().toString().padStart(2, "0")
  const month = (date.getMonth() + 1).toString().padStart(2, "0")
  const year = date.getFullYear()
  const hours = date.getHours().toString().padStart(2, "0")
  const minutes = date.getMinutes().toString().padStart(2, "0")
  return `${hours}:${minutes} ${day}/${month}/${year}`
}

export default function TrafficIndividual({
  data,
  breadCrumbs,
  umbraco,
}: {
  data: TrafficUpdateSinglePage
  breadCrumbs: BreadCrumbs
  umbraco: boolean
}) {
  return (
    <>
      <BreadContainer>
        <Breadcrumbs breadCrumbs={breadCrumbs} />
      </BreadContainer>
      <Container paddingMobile={true}>
        <StyledContainer>
          <TraffixBox el={data} individual />
          <TextContainer>
            {data.itemsList?.map((el, i) => (
              <TextBox key={i}>
                <Typography variant="body1" fontWeight={500}>
                  {el.title}
                </Typography>
                <Typography
                  variant="body1"
                  dangerouslySetInnerHTML={{ __html: el.content }}
                />
              </TextBox>
            ))}
            {!umbraco && (
              <>
                <TextBox>
                  <Typography
                    variant="body1"
                    className="description"
                    dangerouslySetInnerHTML={{
                      __html: decodeUnicodeEscapes(data.descriptionTextHe),
                    }}
                    style={{ whiteSpace: "pre-line" }}
                  />
                </TextBox>
                <TextBox>
                  <Typography variant="body1" fontWeight={700}>
                    תוקף ההודעה:
                  </Typography>
                  <Typography variant="body1">
                    {formatDate(data.activePeriodEnd)} –{" "}
                    {formatDate(data.activePeriodStart)}
                  </Typography>
                </TextBox>
                {(data.type === 2 || data.type === 3) &&
                data.canceledMotStop?.length > 0 ? (
                  <TextBox>
                    <>
                      <Typography variant="body1" fontWeight={700}>
                        תחנות מבוטלות:
                      </Typography>
                      <Typography variant="body1">
                        {data.canceledMotStop?.map(
                          (line, index) =>
                            `${line.key} ל${line.value}${index < data.canceledMotStop.length - 1 ? "; " : ""}`,
                        )}
                      </Typography>
                    </>
                  </TextBox>
                ) : null}

                {data.type === 2 && data.addMotStop?.length > 0 ? (
                  <TextBox>
                    <Typography variant="body1" fontWeight={700}>
                      תחנות חלופיות:
                    </Typography>
                    <Typography variant="body1">
                      {data.addMotStop?.map(
                        (line, index) =>
                          `${line.key} ל${line.value}${index < data.addMotStop.length - 1 ? "; " : ""}`,
                      )}
                    </Typography>
                  </TextBox>
                ) : null}
              </>
            )}
          </TextContainer>
        </StyledContainer>
      </Container>
    </>
  )
}
